import styled from 'styled-components'

export const Heading = styled.h2`
  margin-top: 48px;
  margin-bottom: 30px;
  position: relative;
  z-index: 1;

  &:before {
    border-top: 1px solid ${ (props) => props.theme.colors.grau2 };
    height: 2px;
    content: '';
    margin: 0 auto; /* this centers the line to the full width specified */
    position: absolute; /* positioning must be absolute here, and relative positioning must be applied to the parent */
    top: 50%;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    z-index: -1;
  }

  span {
    /* to hide the lines from behind the text, you have to set the background color the same as the container */
    background: ${ (props) => props.theme.colors['hintergrund-allgemein'] };
    padding-right: 25px;
  }
`
